import { ReduxUtils } from '../../../dependencies';
import { types } from '../../actions';

const actionTypes = {
    REQUEST: types.UPDATE_EXPORT_REQUEST,
    SUCCESS: types.UPDATE_EXPORT_SUCCESS,
    FAILURE: types.UPDATE_EXPORT_FAILURE,
    CANCEL: types.UPDATE_EXPORT_CANCEL,
};

const apiReducer = ReduxUtils.basicApiReducer({
    actionTypes,
});

export default ReduxUtils.containerReducer({
    childReducer: apiReducer,
    actionTypes: Object.values(actionTypes),
    selectors: {
        itemId: action => action.meta.id,
    },
});
